import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const PandL = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div className="row">
              <div class="col-md-12">
                <div className="shadowclass mt-3">
                  <div class="inventory_summary_master">
                    <div class="row-fluid">
                      <div class="col-12">
                        <div class="counts date_new_Cont">
                          <h4 class="event-alert">Select Your Period</h4>

                          <div class="half_new_div d-flex">
                            <a href="#_" class="date_label">
                              <i class="iconSprites arrow-left"></i>{" "}
                            </a>{" "}
                            <span class="date-text">
                              May 1, 2022 - May 12, 2022
                            </span>
                            <span class="clander_icon"></span>
                          </div>

                          <div class="half_right_div">
                            <ul class="summary_filter add">
                              <li class="active">
                                <a href="/finance_summary/pandl/timeLimit:month">
                                  Month
                                </a>{" "}
                              </li>
                              <li class="">
                                <a href="/finance_summary/pandl/timeLimit:quarter">
                                  Quarter
                                </a>{" "}
                              </li>
                              <li class="">
                                <a href="/finance_summary/pandl/timeLimit:year">
                                  Year
                                </a>{" "}
                              </li>
                            </ul>
                            <a href="#" class="print-cammond invent-print"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="shadowclass mt-3">
                  <div class="col-12">
                    <div class="select-comparison">
                      <label class="key">Key Statistics Vs.</label>
                      <div class="select-div widthextra">
                        <select
                          name="data[comparison]"
                          class="comparison"
                          id="comparison"
                        >
                          <option value="">Select Comparison</option>
                          <option value="0" selected="selected">
                            Previous Period
                          </option>
                          <option value="1">Same Period Previous Year</option>
                        </select>{" "}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 m-0">
                    <ul class="comparison_listing statistics_data">
                      <li>
                        <h4>
                          $3,406 <span class="before">77%</span>{" "}
                        </h4>
                        <p>Total Revenue</p>
                      </li>
                      <li>
                        <h4>94 </h4>
                        <p>Total # of Transactions</p>
                      </li>
                      <li>
                        <h4>
                          $284 <span class="before">53%</span>{" "}
                        </h4>
                        <p>Avg. Revenue Per Day</p>
                      </li>
                      <li>
                        <h4>8 </h4>
                        <p>Avg. # of Transactions Per Day</p>
                      </li>
                      <li>
                        <h4>
                          <span class="com-sign">$36</span>
                        </h4>
                        <p>Avg. Ticket Amount</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button mb-0 border-bottom-0"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">
                        Profit &amp; Loss{" "}
                      </h4>
                    </div>{" "}
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="shadowclass mt-0 border-top-0 pt-0">
                      <div className="container px-0">
                        <div class="row justify-content-end">
                          <ul
                            class="nav summary_filter col-md-4"
                            id="pills-tab"
                            role="tablist"
                          >
                            <li class="nav-item" role="presentation">
                              <a
                                class="nav-link active"
                                id="current-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#current"
                                type="button"
                                role="tab"
                                aria-controls="current"
                                aria-selected="true"
                              >
                                Current
                              </a>
                            </li>
                            <li class="nav-item" role="presentation">
                              <a
                                class="nav-link"
                                id="former-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#former"
                                type="button"
                                role="tab"
                                aria-controls="former"
                                aria-selected="false"
                              >
                                Former
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div class="row top-select mx-0">
                          <div class="select-div col-lg-4 col-12 d-flex">
                            <label
                              for="breakdown_discount_by"
                              className="col-md-5"
                            >
                              Breakdown Discount By
                            </label>
                            <select
                              name="data[breakdown_discount_by]"
                              id="breakdown_discount_by"
                            >
                              <option value="9" selected="selected">
                                Food &amp; Beverage
                              </option>
                              <option value="10">
                                Discount/Promotion Group
                              </option>
                            </select>
                          </div>
                          <div class="select-div col d-flex mx-lg-2">
                            <label
                              for="breakdown_sales_by"
                              className="col-md-5"
                            >
                              Breakdown Sales By
                            </label>
                            <select
                              name="data[breakdown_sales_by]"
                              id="breakdown_sales_by"
                            >
                              <option value="1" selected="selected">
                                Payment Methods
                              </option>
                              <option value="2">Menu Item Categories</option>
                              <option value="3">Sales Types</option>
                              <option value="4">Service Period</option>
                            </select>
                          </div>

                          <div class="select-div col-lg-4 col-12 d-flex">
                            <label for="breakdown_cogs_by" className="col-md-5">
                              Breakdown COGS By
                            </label>
                            <select
                              name="data[breakdown_cogs_by]"
                              id="breakdown_cogs_by"
                            >
                              <option value="5" selected="selected">
                                Menu Item Categories
                              </option>
                              <option value="6">Ingredient Categories</option>
                            </select>
                          </div>
                        </div>

                        <div class="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="current"
                            role="tabpanel"
                            aria-labelledby="current-tab"
                          >
                            <div className="table-responsive">
                              <table className="checklist-table remove-space inventory_table">
                                <thead className="border-bottom-0">
                                  <tr>
                                    <th></th>
                                    <th colspan="2">
                                      <span className="months-name">July</span>
                                    </th>
                                    <th colspan="2">
                                      <span className="months-name">June</span>
                                    </th>
                                    <th colspan="2">
                                      <span className="months-name">May</span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="border-bottom">
                                    <td class="text-left"></td>
                                    <td class="text-left">
                                      <strong>Amount</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>% of Revenue</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>Amount</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>% of Revenue</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>Amount</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>% of Revenue</strong>
                                    </td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">
                                      <strong>Gross Revenue</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$6,045.22</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>100</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$20,650.42</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>100</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$11,422.71</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>100</strong>
                                    </td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Food Discounts</td>
                                    <td class="text-left">($45.16)</td>
                                    <td class="text-left">0.75</td>
                                    <td class="text-left">($191.15)</td>
                                    <td class="text-left">0.93</td>
                                    <td class="text-left">($18.20)</td>
                                    <td class="text-left">0.16</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">
                                      Beverage Discounts
                                    </td>
                                    <td class="text-left">($10.00)</td>
                                    <td class="text-left">0.17</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0.00</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0.00</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">
                                      <strong>Total Revenue</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$5,990.06</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>99.09</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$20,459.27</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>99.07</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$11,404.51</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>99.84</strong>
                                    </td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Cash</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$2,863.99</td>
                                    <td class="text-left">14.51</td>

                                    <td class="text-left">$275.10</td>
                                    <td class="text-left">2.52</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Grabfood</td>
                                    <td class="text-left">$123.69</td>
                                    <td class="text-left">2.14</td>

                                    <td class="text-left">$1,833.32</td>
                                    <td class="text-left">9.29</td>

                                    <td class="text-left">$1,712.55</td>
                                    <td class="text-left">15.69</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">VISA</td>
                                    <td class="text-left">$50.30</td>
                                    <td class="text-left">0.87</td>

                                    <td class="text-left">$1,888.00</td>
                                    <td class="text-left">9.57</td>

                                    <td class="text-left">$815.25</td>
                                    <td class="text-left">7.47</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Food Panda</td>
                                    <td class="text-left">$53.27</td>
                                    <td class="text-left">0.92</td>

                                    <td class="text-left">$515.82</td>
                                    <td class="text-left">2.61</td>

                                    <td class="text-left">$315.00</td>
                                    <td class="text-left">2.89</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Deliveroo</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$925.00</td>
                                    <td class="text-left">4.69</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Paytm</td>
                                    <td class="text-left">$50.00</td>
                                    <td class="text-left">0.86</td>

                                    <td class="text-left">$1,035.55</td>
                                    <td class="text-left">5.25</td>

                                    <td class="text-left">$600.30</td>
                                    <td class="text-left">5.5</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">AMEX</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$1,190.09</td>
                                    <td class="text-left">6.03</td>

                                    <td class="text-left">$1,433.75</td>
                                    <td class="text-left">13.14</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">AMEX 2</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$2,446.39</td>
                                    <td class="text-left">12.4</td>

                                    <td class="text-left">$0.10</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Paypal</td>
                                    <td class="text-left">$1,570.00</td>
                                    <td class="text-left">27.15</td>

                                    <td class="text-left">$3,427.69</td>
                                    <td class="text-left">17.37</td>

                                    <td class="text-left">$1,996.64</td>
                                    <td class="text-left">18.3</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">HDFC</td>
                                    <td class="text-left">$157.21</td>
                                    <td class="text-left">2.72</td>

                                    <td class="text-left">$3,608.54</td>
                                    <td class="text-left">18.29</td>

                                    <td class="text-left">$3,763.91</td>
                                    <td class="text-left">34.49</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">AP voucher</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">MasterCard </td>
                                    <td class="text-left">$1,312.87</td>
                                    <td class="text-left">22.71</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">AP E-voucher</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">
                                      Standard Pre-Paid (Multi-Use)
                                    </td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">
                                      Standard Pre-Paid (Single Use)
                                    </td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">AR Voucher </td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Ascentis</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">Stripe</td>
                                    <td class="text-left">$2,464.35</td>
                                    <td class="text-left">42.62</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>

                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>

                                  <tr class="">
                                    <td class="">Service Charges</td>
                                    <td class="text-left">$263.53</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">$916.03</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">$510.11</td>
                                    <td class="text-left">0</td>
                                  </tr>

                                  <tr class="">
                                    <td class="">Other Operating Income</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">$0.00</td>
                                    <td class="text-left">0</td>
                                  </tr>

                                  <tr>
                                    <td class="text-left">
                                      <strong>Total COGS</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>($3,270.81)</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>56.57</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>($1,591.17)</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>8.06</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>($433.40)</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>3.97</strong>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td class="">Food</td>
                                    <td class="text-left">($1,857.66)</td>
                                    <td class="text-left">32.13</td>
                                    <td class="text-left">($1,041.93)</td>
                                    <td class="text-left">5.28</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr>
                                    <td class="">Alcoholic Beverage</td>
                                    <td class="text-left">($138.24)</td>
                                    <td class="text-left">2.39</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr>
                                    <td class="">Non-Alcoholic Beverage</td>
                                    <td class="text-left">($55.00)</td>
                                    <td class="text-left">0.95</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                  </tr>

                                  <tr class="border_bottom actual_cost_row">
                                    <td class="text-left">
                                      <strong>Gross Profit </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$2,719.25</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 47.03</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$18,868.10</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 95.61</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$10,971.11</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 100.54</strong>
                                    </td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">
                                      <strong>Total Operating Expenses</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$39.79 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>0.69</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$394.75 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>2</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$218.90 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>2.01</strong>
                                    </td>
                                  </tr>
                                  <tr class="">
                                    <td class="">Payroll</td>
                                    <td class="text-left">($39.79)</td>
                                    <td class="text-left">0.69</td>
                                    <td class="text-left">($394.75)</td>
                                    <td class="text-left"> 2</td>
                                    <td class="text-left">($218.90)</td>
                                    <td class="text-left"> 2.01</td>
                                  </tr>
                                  <tr class="">
                                    <td class="">Other Operating Expenses</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="border_bottom actual_cost_row">
                                    <td class="text-left">
                                      <strong>Operating Profit </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$2,679.46 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 46.34</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$18,473.35 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 93.61</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$10,752.21 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 98.53</strong>
                                    </td>
                                  </tr>
                                  <tr class="">
                                    <td class="text-left">
                                      <strong>
                                        Total Other Income/Expenses
                                      </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$0.00 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>0</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$0.00 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>0</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$0.00 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>0</strong>
                                    </td>
                                  </tr>
                                  <tr class="">
                                    <td class="">Interest Income/Expenses</td>
                                    <td class="text-left">$0.00 </td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">$0.00 </td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">$0.00 </td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="">Depreciation/Amortization</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">($0.00)</td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="">Net Gain/Loss From Sale</td>
                                    <td class="text-left">$0.00 </td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">$0.00 </td>
                                    <td class="text-left">0</td>
                                    <td class="text-left">$0.00 </td>
                                    <td class="text-left">0</td>
                                  </tr>
                                  <tr class="">
                                    <td class="">
                                      <strong>Total Taxes</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$0.00 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>0</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$0.00 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>0</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$0.00 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>0</strong>
                                    </td>
                                  </tr>
                                  <tr class="border_bottom actual_cost_row">
                                    <td class="text-left">
                                      <strong>Net Income</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$2,679.46 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 46.34</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$18,473.35 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 93.61</strong>
                                    </td>
                                    <td class="text-left">
                                      <strong>$10,752.21 </strong>
                                    </td>
                                    <td class="text-left">
                                      <strong> 98.53</strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div
                            className="tab-pane fade"
                            id="former"
                            role="tabpanel"
                            aria-labelledby="former-tab"
                          >
                            <table className="checklist-table remove-space inventory_table">
                              <tbody>
                                <tr>
                                  <td colspan="5">
                                    <strong>Attachments </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div
                            className="tab-pane fade"
                            id="qr-list"
                            role="tabpanel"
                            aria-labelledby="qr-list-tab"
                          >
                            <table className="checklist-table remove-space inventory_table">
                              <tbody>
                                <tr>
                                  <td colspan="5">
                                    <strong>Opposing Entry </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div
                            className="tab-pane fade"
                            id="related-doc"
                            role="tabpanel"
                            aria-labelledby="related-doc-tab"
                          >
                            <table className="checklist-table remove-space inventory_table">
                              <tbody>
                                <tr>
                                  <td colspan="5">
                                    <strong>RELATED DOCUMENTS </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default PandL;
